module.exports = __webpack_public_path__ + "static/media/2021calendar.3eb0c565.png";